export enum TipoValor {
  Alicuota = 0,
  ValorFijo = 1
  }
